/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoTipEntry = {
    properties: {
        match: {
            type: 'any-of',
            contains: [{
                type: 'MatchSmall',
            }, {
                type: 'null',
            }],
        },
        matchId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        question: {
            type: 'any-of',
            contains: [{
                type: 'Translation',
            }, {
                type: 'null',
            }],
        },
        questionId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        totoGameId: {
            type: 'number',
            isRequired: true,
        },
        totoPlayerId: {
            type: 'number',
            isRequired: true,
        },
        prediction1: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        prediction: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
        },
        prediction2: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        points: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
